import { configureStore, Action, ThunkAction } from "@reduxjs/toolkit";
import rootReducer, { RootState } from "./root-reducer";

const store = configureStore({
  reducer: rootReducer,
});

if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept("./root-reducer", () => {
    const newRootReducer = require("./root-reducer").default;
    store.replaceReducer(newRootReducer);
  });
}

export type AppDispatch = typeof store.dispatch;

/**
 * @type AppThunk
 * @description The AppThunk type declares that the "action" that we're using is specifically a thunk function.
 * The thunk is customized with some additional type parameters:
 * - Return value: the thunk doesn't return anything
 * - State type for `getState`: returns our RootState type
 * - "Extra argument": the thunk middleware can be customized to pass in an extra value, but we aren't ussing that currently
 * - Action types accepted by `dispatch`: any action whose type is a string.
 *
 */
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export default store;
